export enum PolicyType {
  Terms = 'terms',
  Privacy = 'privacy',
  TermsPaid = 'terms-paid',
  SafeGuard = 'safeguard',
  Operation = 'operation',
  Right = 'right',
  Marketing = 'marketing',
  Friends = 'friends',
  PersonalInformationCollection = 'personal-information-collection',
  PersonalInformationThirdParty = 'personal-information-third-party',
  PersonalInformation = 'personal-information',
  MarketingNight = 'marketing-night',
  UsePersonalInfo = 'use-personal-info',
  PersonalAd = 'personal-ad',
  PaymentService = 'payment-service',
  PrivacySafe = 'privacy-safe',
  MarketingThird = 'marketing-third',
  // 14세 관련 약관
  LegalAgentPrivacy = 'legal-agent-privacy',
  ChildPrivacy = 'child-privacy',
  ChildPersonalInformationThird = 'child-personal-information-third',
  ChildMarketingThird = 'child-marketing-third',
}
